import React from 'react';
import PropTypes from 'prop-types';

/** CONTEXT */
import ThemeContext from '../../context/theme';
/** COMPONENTS */
import { StyledGrid, StyledGridItem } from './styled';

/** GRID ITEM PROP-TYPES */
const gridItemPropTypes = {
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node), // array of fields
    PropTypes.node, // singular field
  ]).isRequired,
};

/**
 * Grid Item Component
 *
 * @param {*} { children, ...otherProps }
 * @returns
 */
export const GridItem = ({ children, ...otherProps }) => {
  const theme = React.useContext(ThemeContext);
  return (
    <StyledGridItem {...otherProps} theme={theme}>
      {children}
    </StyledGridItem>
  );
};

/** GRID PROP-TYPES */
const itemType = PropTypes.shape({
  type: PropTypes.oneOf([GridItem]),
});

const gridPropTypes = {
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(itemType), // array of fields
    itemType, // singular field
  ]).isRequired,
  size: PropTypes.number,
  noGutters: PropTypes.bool,
};

/**
 * Grid Component
 *
 * @param {*} { children, size, noGutters }
 * @returns
 */
const Grid = ({ children, size, noGutters, ...otherProps }) => {
  const theme = React.useContext(ThemeContext);
  return (
    <StyledGrid {...otherProps} noGutters={noGutters} theme={theme}>
      {React.Children.map(children, child =>
        child
          ? React.cloneElement(child, { noGutters, gridSize: size })
          : child,
      )}
    </StyledGrid>
  );
};

/** PROP-TYPE ASSIGNMENT */
Grid.propTypes = gridPropTypes;
Grid.defaultProps = { size: 12, noGutters: false };

GridItem.propTypes = gridItemPropTypes;

export default Grid;
